import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { TelecomBundleSelectionComponent } from '@app/form/components/telecom-bundle-selection/telecom-bundle-selection.component';
import { Move } from '@app/move/interfaces/move';
import { MoveSandbox } from '@app/move/sandboxes/move.sandbox';
import { providerAny, providerOptions } from '@app/telecom/constants/telecom.constants';
import { telecomBannerTooltipResource, telecomBannerUri } from '@app/tots/containers/telecom-qualification/telecom-qualification.constants';
import { FormControlGroups, FormControlNames, TelecomStep } from '@app/tots/tots-wizard.constants';
import { TotsWizardService } from '@app/tots/tots-wizard.service';
import { WizardService } from '@app/ui/wizard/wizard.service';
import { UiPlacement } from '@smooved/ui';

@Component({
    selector: 'app-telecom-qualification',
    templateUrl: 'telecom-qualification.container.html',
})
export class TelecomQualificationContainer implements OnInit {
    @ViewChild(TelecomBundleSelectionComponent, { static: true }) bundleInput: TelecomBundleSelectionComponent;
    public controlNames = FormControlNames;
    public providerOptions = [...providerOptions, providerAny];

    public form: UntypedFormGroup;

    public readonly telecomBannerUri = telecomBannerUri;
    public readonly telecomBannerTooltipResource = telecomBannerTooltipResource;
    public readonly placement = UiPlacement;
    public showBanner = true;

    constructor(private readonly wizardService: WizardService, private readonly moveSandbox: MoveSandbox) {}

    public ngOnInit(): void {
        this.form = this.wizardService.form.get(FormControlGroups.StepQualification) as UntypedFormGroup;
        this.wizardService.setCurrentStep(TelecomStep.Qualification);
    }

    public hideBanner(): void {
        this.showBanner = false;
    }

    public onSubmit(): void {
        if (this.form.invalid) return;
        this.moveSandbox.moveOnce$.subscribe((move) => {
            const { bundle, provider } = this.form.getRawValue();
            const payload: Partial<Move> = {
                createdByFlow: move.createdByFlow,
                interested: move.interested,
                telecomOffer: {
                    ...bundle,
                    providerChoice: provider,
                },
            };
            this.moveSandbox.patchMove(move._id, payload, true, null, (move) => {
                (this.wizardService as TotsWizardService).onSubmitWizard(move);
                this.wizardService.reset();
            });
        });
    }
}
